import { render, staticRenderFns } from "./register.vue?vue&type=template&id=4bc79e26&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"
import style0 from "../asset/css/login.scss?vue&type=style&index=0&id=4bc79e26&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc79e26",
  null
  
)

export default component.exports